import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2021.12.30
 *
 * RAP
 * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=236#6674
 **/
const TakeDeliveryAction = {
    /**
     * 通用
     * @param data
     */
   commonAction(data={},sUrl) {
        return request({
            url: sUrl,
            method: "POST",
            data
        });
    },
};

export default TakeDeliveryAction;
